/**
 * Creates an object with REQUEST, SUCCESS, FAILURE, and RESET action types
 * @param {string} base - Base action name
 * @returns {Object} Object with action type variants
 */
const createActionTypes = (base) => ({
  REQUEST: `patient/${base.toLowerCase()}-request`,
  SUCCESS: `patient/${base.toLowerCase()}-success`,
  FAILURE: `patient/${base.toLowerCase()}-failure`,
  RESET: `patient/${base.toLowerCase()}-reset`
});

// Actions for patient Google authentication
export const patientGoogleAuthActions = {
  GOOGLE_LOGIN: createActionTypes('google-login'),
  GOOGLE_REGISTER: createActionTypes('google-register')
};
